import { useState, useEffect } from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import Home from "../home/home";
import EditClientMaster from "../Pages/clientMaster/editClientMaster";
import EditUserMaster from "../Pages/userMaster/editUserMaster";
import ClientMasterList from "../Pages/clientMaster/clientMasterList";
import UserMasterList from "../Pages/userMaster/userMasterList";
import InspectionItemsMasterList from "../Pages/inspectionItemsMaster/inspectionItemsMasterList";
import EditInspectionItems from "../Pages/inspectionItemsMaster/editInspectionItems";
import DocumentLibraryMasterList from "../Pages/documentLibraryMaster/documentLibraryMasterList";
import EditdocumentLibraryMaster from "../Pages/documentLibraryMaster/editdocumentLibraryMaster";
import CAMMechanicalList from "../Pages/camMechanical/CAMMechanicalList";
import EditCAMMechanical from "../Pages/camMechanical/editCAMMechanical";
import CamElectricalList from "../Pages/camElectrical/camElectricalList";
import EditCamElectrical from "../Pages/camElectrical/editCamElectrical";
import PriceMasterList from "../Pages/priceMaster/priceMasterList";
import EditPriceMaster from "../Pages/priceMaster/editPriceMaster";
import InspectionServiceList from "../Pages/inspection/inspectionServiceList";
import EditInspectionService from "../Pages/inspection/editInspectionService";
import EditCustomerFededback from "../Pages/customerFededback/editCustomerFededback";
import CustomerFededbackList from "../Pages/customerFededback/customerFededbackList";
import EditQuotation from "../Pages/quotation/editQuotationNew";
import QuotationList from "../Pages/quotation/quotationList";
import Dashboard from "../dashboard/dashboard";
import PoAcceptanceList from "../Pages/po_acceptance/poAcceptanceList";
import EditpoAcceptance from "../Pages/po_acceptance/editpoAcceptance";
import Login from "../login/Login";
import EditJobRegister from "../Pages/jobRegister/editJobRegister";
import JobRegisterList from "../Pages/jobRegister/jobRegisterList";
import InspectionTaskList from "../Pages/inspectionTaskList/inspectionTaskList";
import QualificationReport from "../Pages/qualificationReport/qualificationReport";
import ProgressReport from "../Pages/report/progressReport";
import SummaryReport from "../Pages/report/summaryReport";
import WorkReport from "../Pages/report/workReport";
import InspectionReport from "../Pages/inspectionReport/inspectionReport";
import Help from "../help/help";
import CoverLetterList from "../Pages/coverLetter/coverLetterList";
import EditCoverLetter from "../Pages/coverLetter/editCoverLetter";
import CreateCoverLetter from "../Pages/coverLetter/createCoverLetter/createCoverLetter";
import CreateCoverLetterList from "../Pages/coverLetter/createCoverLetter/createCoverLetterList";
import { NotificationList } from "../notification/Notification";
import InspectorSignReport from "../inspectorSignReport/inspectorSignReport";
import GeneralCorrespondentsList from "../Pages/generalCorrespondents/generalCorrespondentsList";
import EditGeneralCorrespondents from "../Pages/generalCorrespondents/editGeneralCorrespondents";
import TimeSheetReport from "../Pages/report/timeSheetReport";
import EmployeeMasterList from "../Pages/employeeMaster/employeeMasterList";
import EditEmployeeMaster from "../Pages/employeeMaster/editEmployeeMaster";
import EmployeeView from "../Pages/employeeMaster/employeeView";
import HolidayList from "../Pages/holiday/HolidayList";
import EditHoliday from "../Pages/holiday/editHoliday";
import RBCAMasterList from "../Pages/rbac/RBCAMasterList";
import EditRBCAMaster from "../Pages/rbac/editRBCAMaster";
import ApplyLeaveUI from "../Pages/leave/applyLeave";
import LeaveReport from "../Pages/leave/leaveReport";
import LeaveBalanceReport from "../Pages/leave/leaveBalanceReport";
import LeaveRegularizationList from "../Pages/LeaveRegulation/leaveRegulationList";
import EditleaveRegularization from "../Pages/LeaveRegulation/editLeaveRegulation";
import AttendanceList from "../Pages/markAttendance/attendanceList";
import AttendanceRegularizationList from "../Pages/AttendanceRegularization/attendanceRegularizationList";
import EditAttendanceRegularization from "../Pages/AttendanceRegularization/editAttendanceRegularization";
import EmployeeCalendar from "../Pages/employeeMaster/employeeCalendar";
import AboutUs from "../home/aboutUs";
import GeneralIRList from "../Pages/GeneralIR/generalIRList";
import EditGeneralIR from "../Pages/GeneralIR/editGeneralIR";
import ViewGeneralIR from "../Pages/GeneralIR/ViewGeneralIR";
import MasterList from "../TalentAcquisition&Development/TalentAcquisition/Masters/MasterList";
import EditMaster from "../TalentAcquisition&Development/TalentAcquisition/Masters/editMaster";
import RequirementsList from "../TalentAcquisition&Development/TalentAcquisition/Requirements/requirementsList";
import EditRequirements from "../TalentAcquisition&Development/TalentAcquisition/Requirements/editRequirements";
import CandidateList from "../TalentAcquisition&Development/TalentAcquisition/Candidate/candidateList";
import EditCandidate from "../TalentAcquisition&Development/TalentAcquisition/Candidate/editCandidate";
import PipelineList from "../TalentAcquisition&Development/TalentAcquisition/Pipeline/pipelineList";
import EditPipeline from "../TalentAcquisition&Development/TalentAcquisition/Pipeline/editPipeline";
import InterviewScheduleList from "../TalentAcquisition&Development/TalentAcquisition/InterviewSchedule/interviewScheduleList";
import EditInterviewSchedule from "../TalentAcquisition&Development/TalentAcquisition/InterviewSchedule/editInterviewSchedule";
import OfferJoiningList from "../TalentAcquisition&Development/TalentAcquisition/OfferJoining/offerJoiningList";
import EditOfferJoining from "../TalentAcquisition&Development/TalentAcquisition/OfferJoining/editOfferJoining";
import ViewOfferJoining from "../TalentAcquisition&Development/TalentAcquisition/OfferJoining/viewOfferJoining";
import EnquiryList from "../Pages/Enquiry/enquiryList";
import EditEnquiry from "../Pages/Enquiry/editEnquiry";
import EnquiryFollowUp from "../Pages/Enquiry/enquiryFollowUp";
import ViewQuotation from "../Pages/quotation/viewQuotation";
import ViewIRReport from "../Pages/inspectionReport/IRVIEW/ViewIRReport";
import QuotationFollowUp from "../Pages/quotation/quotationFollowUp";
import QuotationRatioReport from "../Pages/quotation/quotationRatioReport";
import InspectorScheduleReport from "../Pages/report/inspectorScheduleReport";
import InspectionCallRegisterReport from "../Pages/report/inspectionCallRegisterReport";
import InspectorExpenseDataReport from "../Pages/report/inspectorExpenseDataReport";
import EnquiryRegisterReport from "../Pages/quotation/enquiryRegisterReport";
import EditJobDescription from "../Pages/jobDescriptionMaster/editJobDescription";
import JobDescriptionList from "../Pages/jobDescriptionMaster/jobDescriptionList";
import AllEmployeeForms from "../Pages/employeeMaster/allEmployeeforms";


const Main = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // Check if user is logged in
  const [isLoggedIn, setIsLoggedIn] = useState(sessionStorage.getItem("isLoggedIn"));
  let username = sessionStorage.getItem("logInUser") || "";

  // ---- NOTIFICATION ----
  const [notificationsNo, setNotificationsNo] = useState(0);
  const [anchorNotification, setAnchorNotification] = useState(null);
  const openNotification = Boolean(anchorNotification);
  const handleNotificationClick = (event) => {
    if (!anchorNotification) setAnchorNotification(event.currentTarget);
    else setAnchorNotification(null);
  };
  const handleNotificationClose = () => setAnchorNotification(null);

  // Check if current route is a public route (QR inspection report)
  const isPublicRoute = () => {
    const currentRoute = window.location.hash || "#/";
    return (
      currentRoute.startsWith("#/inspectionReport/print/qr/") ||
      currentRoute.startsWith("#/editCoverLetter/print/qr/") ||
      currentRoute.startsWith("#/createReport/print/qr/")
    );
  };
  useEffect(() => {
    const authToken = sessionStorage.getItem("isLoggedIn");
    const currentRoute = window.location.hash || "#/";
    // Routes that should NOT redirect to login
    const ignoreAuthRoutes = [
      "#/inspectionReport/print/qr/",
      "#/editCoverLetter/print/qr/",
      "#/createReport/print/qr/",
    ];
    const isIgnoredRoute = ignoreAuthRoutes.some(route =>
      currentRoute.startsWith(route)
    );
    if (!authToken && !isIgnoredRoute && currentRoute !== "#/" && currentRoute !== "") {
      window.location.href = "/";
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      if (mobile !== isMobile) {
        setIsMobile(mobile);
        // Auto-close sidebar on mobile by default
        if (mobile) {
          setSidebarOpen(false);
        } else {
          setSidebarOpen(true);
        }
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [isMobile]);

  // Render public route without login/sidebar
  if (isPublicRoute()) {
    return (
      <HashRouter>
        <div className="min-h-screen w-full">
          <Routes>
            <Route
              path="/inspectionReport/print/qr/:id"
              element={<InspectionReport print={true} />}
            />
            <Route
              path="/editCoverLetter/print/qr/:id"
              element={<EditCoverLetter print={true} />}
            />
            <Route
              path="/createReport/print/qr/:id"
              element={<CreateCoverLetter print={true} />}
            />
          </Routes>
        </div>
      </HashRouter>
    );
  }

  return (
    <HashRouter>
      {!isLoggedIn ? (
        <div className="min-h-screen w-full">
          <Routes>
            <Route path="*" element={<Login setIsLoggedIn={setIsLoggedIn} />} />

          </Routes>
        </div>
      ) : (
        <AppLayout
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          isMobile={isMobile}
          username={username}
          notificationsNo={notificationsNo}
          onNotificationClick={handleNotificationClick}
          onLogout={() => {
            sessionStorage.clear();
            localStorage.clear();
            setIsLoggedIn(null);
            window.location.reload(true);
          }}
          anchorNotification={anchorNotification}
          openNotification={openNotification}
          handleNotificationClose={handleNotificationClose}
          setNotificationsNo={setNotificationsNo}
        />
      )}
    </HashRouter>
  );
};

// inner layout component — needs to be inside HashRouter to use useLocation
function AppLayout({
  isSidebarOpen, setSidebarOpen, isMobile, username,
  notificationsNo, onNotificationClick, onLogout,
  anchorNotification, openNotification, handleNotificationClose, setNotificationsNo,
}) {
  const location = useLocation();
  const pathname = location.pathname;
  const isHome = pathname === "/" || pathname === "";
  const isAbout = pathname === "/about";

  return (
    <div className="flex flex-col h-screen overflow-hidden relative">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setSidebarOpen={setSidebarOpen}
        isMobile={isMobile}
        username={username}
        notificationsNo={notificationsNo}
        onNotificationClick={onNotificationClick}
        onLogout={onLogout}
        isHome={isHome}
      />

      {/* on home the navbar overlays the hero; about keeps full-width but uses solid header */}
      <div className={`overflow-y-auto ${isHome || isAbout ? "flex-1" : "flex-1 p-4 sm:p-6"}`}>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/dashboard" element={<Dashboard moduleId={100} />} />

          <Route path="/master/employeeMaster" element={<EmployeeMasterList moduleId={21} />} />

          {/* <Route path="/master/employeeMasterEdit/:id" element={<EditEmployeeMaster moduleId={21} />} /> */}

          <Route path="/master/employeeMasterEdit/:id" element={<AllEmployeeForms moduleId={21} />} />


          <Route path="/master/employeeMasterPrint/:id" element={<EmployeeView moduleId={21} />} />
          <Route path="/master/employeeCalendar/:id" element={<EmployeeCalendar moduleId={21} />} />

          <Route path="/master/holiday" element={<HolidayList moduleId={13} />} />
          <Route path="/master/editHoliday/:id" element={<EditHoliday moduleId={13} />} />

          <Route path="/master/jobDescription" element={<JobDescriptionList moduleId={17} />} />
          <Route path="/master/editJobDescription/:id" element={<EditJobDescription moduleId={17} />} />

          <Route path="/master/rbacList" element={<RBCAMasterList />} />

          <Route path="/master/editRBCA/:id" element={<EditRBCAMaster />} />

          <Route path="/leave/apply" element={<ApplyLeaveUI moduleId={8231} />} />

          <Route path="/leave/edit/:id" element={<ApplyLeaveUI moduleId={8231} />} />

          <Route path="/leave/report" element={<LeaveReport moduleId={8232} />} />

          <Route path="/leave/balanceReport" element={<LeaveBalanceReport moduleId={8233} />} />

          <Route path="/leave/leaveRegularization" element={<LeaveRegularizationList moduleId={8234} />} />

          <Route path="/leave/editleaveRegularization/:id" element={<EditleaveRegularization moduleId={8234} />} />

          <Route path="/master/users/:id" element={<EditUserMaster moduleId={12} />} />

          <Route path="/master/usersList" element={<UserMasterList moduleId={12} />} />

          <Route path="/master/clients/:id" element={<EditClientMaster moduleId={23} />} />

          <Route path="/master/clientsList" element={<ClientMasterList moduleId={23} />} />

          <Route path="/master/inspectionItems/:id" element={<EditInspectionItems moduleId={11} />} />

          <Route path="/master/inspectionItemsList" element={<InspectionItemsMasterList moduleId={11} />} />

          <Route path="/master/documentLibrary/:id" element={<EditdocumentLibraryMaster moduleId={14} />} />

          <Route path="/master/documentLibraryList" element={<DocumentLibraryMasterList moduleId={14} />} />

          <Route path="/camMechanical/:id" element={<EditCAMMechanical moduleId={221} />} />

          <Route path="/camMechanicalList" element={<CAMMechanicalList moduleId={221} />} />

          <Route path="/camElectrical/:id" element={<EditCamElectrical moduleId={222} />} />

          <Route path="/camElectricalList" element={<CamElectricalList moduleId={222} />} />

          <Route path="/master/price/:id" element={<EditPriceMaster moduleId={15} />} />

          <Route path="/master/priceList" element={<PriceMasterList moduleId={15} />} />

          <Route path="/inspectionService/:id" element={<EditInspectionService moduleId={4124} />} />

          <Route path="/inspectionService/print/:id" element={<EditInspectionService print={true} moduleId={4124} />} />

          <Route path="/inspectionServiceList" element={<InspectionServiceList moduleId={4124} />} />

          <Route path="/customerFededback/:id" element={<EditCustomerFededback moduleId={551} />} />

          <Route path="/customerFededback/print/:id" element={<EditCustomerFededback print={true} moduleId={551} />} />

          <Route path="/customerFededbackList" element={<CustomerFededbackList moduleId={551} />} />

          <Route path="/quotation/:id" element={<EditQuotation moduleId={312} />} />
          <Route path="/viewQuotation/:id" element={<ViewQuotation moduleId={312} />} />
          <Route path="/quotation/print/:id" element={<EditQuotation print={true} moduleId={312} />} />
          <Route path="/quotationList" element={<QuotationList moduleId={312} />} />
          <Route path="/quotationFollowUp/:id" element={<QuotationFollowUp moduleId={312} />} />
          <Route path="/quotationRatioReport" element={<QuotationRatioReport moduleId={3222} />} />
          <Route path="/enquiryRegisterReport" element={<EnquiryRegisterReport moduleId={3221} />} />

          <Route path="/editpoAcceptance/:id" element={<EditpoAcceptance moduleId={313} />} />

          <Route path="/poAcceptanceList" element={<PoAcceptanceList moduleId={313} />} />

          <Route path="/editJobRegister/:id" element={<EditJobRegister moduleId={4111} />} />

          <Route path="/jobRegisterList" element={<JobRegisterList moduleId={4111} />} />

          <Route path="/inspectionTaskList" element={<InspectionTaskList moduleId={4112} />} />
          <Route path="/viewIRReport/:id" element={<ViewIRReport moduleId={4122} />} />

          <Route path="/createCoverLetterList" element={<CreateCoverLetterList moduleId={41231} />} />

          <Route path="/camreport" element={<QualificationReport moduleId={223} />} />

          <Route path="/SummaryReport" element={<SummaryReport moduleId={10112} />} />

          <Route path="/progressReport" element={<ProgressReport moduleId={10113} />} />

          <Route path="/workReport" element={<WorkReport moduleId={10114} />} />

          <Route path="/inspectorscheduleReport" element={<InspectorScheduleReport moduleId={4121} />} />
          <Route path="/inspectionCallRegisterReport" element={<InspectionCallRegisterReport moduleId={4122} />} />
          <Route path="/timesheetDataReport" element={<InspectorExpenseDataReport moduleId={1017} />} />

          <Route path="/inspectorsignreport" element={<InspectorSignReport moduleId={10115} />} />

          <Route path="/inspectionReport/:id" element={<InspectionReport moduleId={4122} />} />

          <Route path="/inspectionReport/print/:id" element={<InspectionReport print={true} moduleId={4122} />} />

          <Route path="/createReport/:id" element={<CreateCoverLetter moduleId={41231} />} />

          <Route path="/createReport/print/:id" element={<CreateCoverLetter print={true} moduleId={41231} />} />

          <Route path="/editCoverLetter/:id" element={<EditCoverLetter moduleId={41232} />} />

          <Route path="/editCoverLetter/print/:id" element={<EditCoverLetter print={true} moduleId={41232} />} />

          <Route path="/coverLetterList" element={<CoverLetterList moduleId={41232} />} />

          <Route path="/generalCorrespondentsList" element={<GeneralCorrespondentsList moduleId={41233} />} />

          <Route path="/editgeneralCorrespondents/:id" element={<EditGeneralCorrespondents moduleId={41233} />} />

          <Route path="/editgeneralCorrespondents/print/:id" element={<EditGeneralCorrespondents moduleId={41233} />} />

          <Route path="/attendance" element={<AttendanceList moduleId={8211} />} />

          <Route path="/attendanceRegularizationList" element={<AttendanceRegularizationList moduleId={8212} />} />

          <Route path="/editAttendanceRegularization/:id" element={<EditAttendanceRegularization moduleId={8212} />} />

          <Route path="/timeSheetReport" element={<TimeSheetReport moduleId={10116} />} />

          <Route path="/generalIRList" element={<GeneralIRList moduleId={4113} />} />
          <Route path="/editGeneralIR/:id" element={<EditGeneralIR moduleId={4113} />} />
          <Route path="/viewGeneralIR/:id" element={<ViewGeneralIR moduleId={4113} />} />

          <Route path="/enquiryList" element={<EnquiryList moduleId={311} />} />
          <Route path="/editEnquiry/:id" element={<EditEnquiry moduleId={311} />} />
          <Route path="/enquiryFollowUp/:id" element={<EnquiryFollowUp moduleId={311} />} />

          <Route path="/help" element={<Help print={true} />} />

          <Route path="/talent-acquisition/masters" element={<MasterList moduleId={616} />} />
          <Route path="/talent-acquisition/editMaster/:id" element={<EditMaster moduleId={616} />} />
          <Route path="/talent-acquisition/requirements" element={<RequirementsList moduleId={611} />} />
          <Route path="/talent-acquisition/editRequirements/:id" element={<EditRequirements moduleId={611} />} />
          <Route path="/talent-acquisition/candidates" element={<CandidateList moduleId={612} />} />
          <Route path="/talent-acquisition/editCandidate/:id" element={<EditCandidate moduleId={612} />} />
          <Route path="/talent-acquisition/pipeline" element={<PipelineList moduleId={613} />} />
          <Route path="/talent-acquisition/editPipeline/:id" element={<EditPipeline moduleId={613} />} />
          <Route path="/talent-acquisition/interview-schedules" element={<InterviewScheduleList moduleId={614} />} />
          <Route path="/talent-acquisition/editInterviewSchedule/:id" element={<EditInterviewSchedule moduleId={614} />} />
          <Route path="/talent-acquisition/offers" element={<OfferJoiningList moduleId={615} />} />
          <Route path="/talent-acquisition/editOffer/:id" element={<EditOfferJoining moduleId={615} />} />
          <Route path="/talent-acquisition/viewOffer/:id" element={<ViewOfferJoining moduleId={615} />} />

        </Routes>
      </div>

      {/* Notification list */}
      <NotificationList
        anchorEl={anchorNotification}
        open={openNotification}
        close={handleNotificationClose}
        notifyNumber={(n) => setNotificationsNo(n)}
      />
    </div>
  );
}

export default Main;
